import { ResolveFn } from '@angular/router';
import { PRODUCT_DATA } from './product-loaders';
import { Product } from './product-types';

// A resolver, not ngOnInit: the router waits for it, so server rendering always has the data.
// The route's canMatch has already checked the product exists.
// product-copy is imported on demand so the product index stays out of the main bundle.
export const productResolver: ResolveFn<Product | undefined> = async route => {
  const { findProduct } = await import('./product-copy');
  const entry = findProduct(route.paramMap.get('product'));
  if (!entry) return undefined;
  const list = await PRODUCT_DATA[entry.chunk]();
  return list.find(p => p.hs === entry.hs);
};
